import React from 'react'
import { useTranslation } from 'react-i18next'

import { FormikProps } from 'formik'
import { Card } from 'primereact/card'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { classNames } from 'primereact/utils'

import { PanelContainer } from '../../../../../components/Panel'
import { EditSupplierFormDto, SupplierDetail } from '../../data'
import { SupplierFormFieldName } from '../Supplier.data'

type Props = {
  isEdit: boolean
  isRequestRunning: boolean
  isLoading: boolean
  formik: FormikProps<EditSupplierFormDto>
  isFormFieldInvalid: (name: SupplierFormFieldName) => boolean
  getFormErrorMessage: (name: SupplierFormFieldName) => JSX.Element
}
export const SupplierInformation: React.FC<Props> = ({
  isEdit,
  isRequestRunning,
  isLoading,
  formik,
  isFormFieldInvalid,
  getFormErrorMessage,
}) => {
  const { t } = useTranslation()

  return (
    <PanelContainer
      header={t('supplier.supplierInformation.title')}
      id="supplier-supplierInformation"
      toggleable={false}
    >
      <div className="grid">
        <div className="col-12 lg:col-4">
          <p>{t('supplier.supplierInformation.subtitle')}</p>
        </div>
        <div className="col-12 lg:col-7 lg:col-offset-1">
          <Card className="md:px-4">
            <div className="formgrid grid">
              {/* Id */}
              <div className="col-12 md:col-4">
                <label className="text-xs font-bold block mb-2" htmlFor="id">
                  {t('supplier.supplierInformation.form.id.label')}
                </label>
                <InputText
                  id="id"
                  value={formik.values.id}
                  className="w-full"
                  disabled
                />
              </div>

              {/* Name */}
              <div className="col-12 md:col-8">
                <label
                  className={classNames('text-xs font-bold block mb-2', {
                    'p-error': isFormFieldInvalid('name'),
                  })}
                  htmlFor="name"
                >
                  <span className="text-red-500 font-bold mr-1">*</span>
                  {t('supplier.supplierInformation.form.name.label')}
                </label>
                <InputText
                  id="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  className={classNames('w-full', {
                    'p-invalid': isFormFieldInvalid('name'),
                  })}
                  disabled={!isEdit || isRequestRunning}
                />
                <div>{getFormErrorMessage('name')}</div>
              </div>

              {/* Description */}
              <div className="col-12">
                <label
                  className={classNames('text-xs font-bold block mb-2', {
                    'p-error': isFormFieldInvalid('description'),
                  })}
                  htmlFor="description"
                >
                  {t('supplier.supplierInformation.form.description.label')}
                </label>
                <InputTextarea
                  id="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  rows={5}
                  className={classNames('w-full', {
                    'p-invalid': isFormFieldInvalid('description'),
                  })}
                  disabled={!isEdit || isRequestRunning}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
    </PanelContainer>
  )
}
